module.exports = {
  path: ':reference',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MyOnDemandAccess'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/my_on_demand_access/routes/show/index.js